import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { SubSink } from "subsink";
import { Store } from "@ngrx/store";
import {
  IAppState,
  PropertySelectors,
  LoaderService,
  FolderBrowserWidget,
  UserService,
  PulseCommonModule,
} from "@pulse/common";
import {
  AppConfigService,
  AppDataSharingService,
} from "@pulse/common";
import { PropertiesDocumentsService } from "../../../properties/properties-documents/properties-documents.service";
import { Constatnts } from "../../../../assets/constants/constants";
import { TranslateService } from "@ngx-translate/core";
import { languageMappings } from '../../script-hack/ot-language-files';
@Component({
  selector: "app-add-document",
  templateUrl: "./add-document.component.html",
  styleUrls: ["./add-document.component.scss"],
})
export class AddDocumentComponent implements OnInit, OnDestroy {
  errorMsg: string;
  error: boolean = false;
  otdsToken;
  isLoaderVisible = false;
  private folderBrowserParent = "#newDocCtnr";
  @Output() hideDialog = new EventEmitter<string>();
  propertyId;
  showDocsWidget: boolean = false;
  subs = new SubSink();
  style = { "min-height": "40%" };
  mappings = languageMappings;
  constructor(
    private config: AppConfigService,
    private appDataSharingService: AppDataSharingService,
    private propertiesDocumentsService: PropertiesDocumentsService,
    private store: Store<IAppState>,
    private translateService: TranslateService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.showDocsWidget = true;
    this.otdsToken = this.appDataSharingService.getOtdsTicket();
    if (this.otdsToken) {
      this.propertyId = this.appDataSharingService.getPropertyId();
      if (this.propertyId) {
        this.subs.add(
          this.store
            .select(PropertySelectors.getProperty)
            .subscribe((property) => {
              if (property) {
                this.getNodeId(
                  this.propertiesDocumentsService.getPropNickName(property)
                );
              }
            })
        );
      } else {
        const data = this.appDataSharingService.getDocRootInfo();
        if (data) {
          this.renderFolderBrowserWidget(data);
        } else {
          this.getNodeId(
            this.propertiesDocumentsService.getRootFolderNickName()
          );
        }
      }
    } else {
      this.error = true;
      this.errorMsg = this.translateService.instant(
        Constatnts.ERROR_MSG_USER_OT
      );
    }
  }

  getNodeId(nickName) {
    let post_obj = {
      nickname: nickName,
      ticket: this.appDataSharingService.getOtdsTicket(),
    };

    this.propertiesDocumentsService.getPropertyCSNodeId(post_obj).subscribe(
      (data) => {
        this.renderFolderBrowserWidget(data);
      },
      (err) => {
        this.error = true;
        this.errorMsg = err.error.message;
      }
    );
  }

  renderFolderBrowserWidget(data: any = {}) {
    this.showLoader(true);
    let url_obj = {
      url: `${this.config.get("content_server_url")}`,
      supportPath: "/img",
    };

    const userInfo = this.userService.getUserInfo();
    const langPreferences = this.mappings[userInfo.preferences["language-code"].toLowerCase()];

    FolderBrowserWidget(
      this.otdsToken,
      data,
      url_obj,
      this.folderBrowserParent,
      (object: any) => {
        this.showLoader(object);
      },
      langPreferences
    );
    setTimeout(() => {
      this.showLoader(false);
    }, 5000);
  }
  showLoader(flag: boolean) {
    this.isLoaderVisible = flag;
  }
  close() {
    this.hideDialog.next("close");
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
